import React from 'react';
import { PropTypes as T } from 'prop-types';
import { FormGroup } from 'reactstrap';

import Address from 'app/models/address';

import Base from 'app/components/model_forms/base';
import BoundInput from 'app/components/forms/input/bound_input';
import FormRow from 'app/components/bootstrap/form_row';
import ColFormLabel from 'app/components/bootstrap/col_form_label';

export default class AddressForm extends Base {
  static propTypes = {
    model: T.instanceOf(Address).isRequired,
  }

  render() {
    const { model } = this.props;

    return (
      <div>
        <FormRow>
          <FormGroup className="col-md-6">
            <ColFormLabel>Name</ColFormLabel>
            <BoundInput bsSize="sm" type="text" property="name" model={model} />
          </FormGroup>

          <FormGroup className="col-md-6">
            <ColFormLabel>Company</ColFormLabel>
            <BoundInput bsSize="sm" type="text" property="company" model={model} />
          </FormGroup>
        </FormRow>

        <FormRow>
          <FormGroup className="col-md-6">
            <ColFormLabel>Phone</ColFormLabel>
            <BoundInput bsSize="sm" type="tel" property="phone" model={model} />
          </FormGroup>

          <FormGroup className="col-md-6">
            <ColFormLabel>Email</ColFormLabel>
            <BoundInput bsSize="sm" type="email" property="email" model={model} />
          </FormGroup>
        </FormRow>

        <FormRow>
          <FormGroup className="col-md-6">
            <ColFormLabel>Street 1</ColFormLabel>
            <BoundInput bsSize="sm" type="text" property="street1" model={model} />
          </FormGroup>

          <FormGroup className="col-md-6">
            <ColFormLabel>Street 2</ColFormLabel>
            <BoundInput bsSize="sm" type="text" property="street2" model={model} />
          </FormGroup>
        </FormRow>

        <FormRow>
          <FormGroup className="col-md-6">
            <ColFormLabel>City</ColFormLabel>
            <BoundInput bsSize="sm" type="text" property="city" model={model} />
          </FormGroup>

          <FormGroup className="col-md-3">
            <ColFormLabel>State</ColFormLabel>
            <BoundInput bsSize="sm" type="text" property="state" model={model} />
          </FormGroup>

          <FormGroup className="col-md-3">
            <ColFormLabel>Zip</ColFormLabel>
            <BoundInput bsSize="sm" type="text" property="zip" model={model} />
          </FormGroup>
        </FormRow>

        <FormRow>
          <FormGroup className="col-md-6">
            <ColFormLabel>Country</ColFormLabel>
            <BoundInput bsSize="sm" type="text" property="country" model={model} />
          </FormGroup>
        </FormRow>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/model_forms/address/index.jsx